import 'normalize.css'
import './share/rootStyle.styl'
import Vue from 'vue'

import get_param from './tools/param'
import {error_event, console_log, console_error} from "./tools/mgtv/analysis";


window.onerror = function (msg, url, line, col, error) {
  setTimeout(function () {
    error_event(error, "", 'code_error');
  }, 0);
  return true;
};


window.addEventListener('unhandledrejection', function (e) {
  e.preventDefault();
  error_event(e.reason, "", 'code_error');
}, false);


function formatComponentName(vm) {
  if (vm.$root === vm) return 'root';
  var name = vm._isVue ? (vm.$options && vm.$options.name) || (vm.$options && vm.$options._componentTag) : vm.name;
  return (name ? 'component <' + name + '>' : 'anonymous component') + (vm._isVue && vm.$options && vm.$options.__file ? ' at ' + (vm.$options && vm.$options.__file) : '');
}


Vue.config.errorHandler = function (err, vm, info) {
  var componentName = formatComponentName(vm);
  var propsData = vm.$options && vm.$options.propsData;
  error_event(err,
    {
      vue: JSON.stringify({
        componentName: componentName,
        propsData: propsData ? JSON.stringify(propsData) : null,
        info: info
      })
    }, 'code_error');
};



import App from './App'
import {init_gact} from './tools/mgtv/gact'
import './EventBus/index'

init_gact();
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js